import { createSelector } from 'reselect';
import { type AppState } from '../../../types';

const getModalState = (state: AppState) => state.modal;

export const getOpenedModals = createSelector(
  [getModalState],
  (modalState) => modalState.openedModals,
);
